export default __webpack_public_path__ + "static/media/Catherine-Burns.07a5409d.jpg";